import React from 'react';
import styled from 'styled-components';
import {
  SectionWrapper,
  HeadlineOne,
  Paragraph,
  HeadlineTwo,
  WrapperCenter,
} from 'components/atoms/SectionWrapper.style';
import CounterWrapper from '../Counters/CounterWrapper';

const First = styled.div`
  /* height: 350px; */
  /* margin-top: 100px; */
  text-align: justify;
  width: 95%;
  margin: 0 auto;
  padding: 15px;

  @media ${({ theme }) => theme.media.tablet} {
    /* width: 85%;
    padding: 30px;
    border: dashed 4px #218921; */
  }
`;

const Slider = () => (
  <>
    {/* <First> */}
    {/* <CounterWrapper /> */}
    <WrapperCenter>
      <HeadlineOne>O NAS</HeadlineOne>
      <Paragraph>Firma Elgreen powstała w 2009 roku. Głównym obszarem działania firmy jest szeroko rozumiana branża energetyczna. 
Od początku istnienia firmy współpracujemy z biurami projektowymi, architektami i Inwestorami. Międzyinnymi zajmujemy się kompleksowym projektowaniem, począwszy od koncepcji, poprzez obliczenia techniczne, projekty budowlane, wymagane uzgodnienia, aż do pełnej dokumentacji wykonawczej i powykonawczej uwzględniając przygotowanie kosztorysu. Projektujemy zarówno instalacje elektryczne wewnętrzne jak i sieci zewnętrzne nN, SN i WN. Nasza firma wpisana jest na listę wykonawców kwalifikowanych w ENERGA-OPERATOR SA.  Ze względu na doświadczenie oraz wykwalifikowaną kadrę jesteśmy wstanie realizować najtrudniejsze zadania. Jako jedni z pierwszych na pomorzu rozpoczęliśmy projektowanie instalacji elektrycznych i niskoprądowych wewnętrznych w technologii BIM-3D. </Paragraph>
      
      <Paragraph>Realizujemy również inwestycje w formie „zaprojektuj i wybuduj”. </Paragraph>
      <Paragraph>Oferujemy również szeroki zakres usług związanych z elektro mobilnością. Zajmujemy się projektowaniem i budową infrastruktury stacji ładowania pojazdów elektrycznych. Jesteśmy również dystrybutorem i partnerem czołowych Polskich producentów stacji ładowania, jakimi są Ekoenergetyka oraz EVB.</Paragraph>
     
     <Paragraph>Zajmujemy się również realizacją działań z zakresu odnawialnych źródeł energii (OZE).  Inwestycje jesteśmy w stanie realizować kompleksowo począwszy od zaprojektowania, budowę oraz dostarczanie rozwiązań mających na celu redukcje kosztów stałych i budowę autonomii energetycznej zarówno dla klientów indywidualnych jak i przedsiębiorstw. </Paragraph>
     <Paragraph>Oferujemy również analizy oraz optymalizacje kosztów związanych z dostarczeniem energii elektrycznej oraz jej zużyciem.
</Paragraph>

<Paragraph>Wykonujemy również świadectwa charakterystyki energetycznej dla budynków. 
</Paragraph>     
      {/* <HeadlineTwo>Firma ELGREEN PROJEKT</HeadlineTwo> */}
      {/* <Paragraph>
        Firma Elgreen powstała w 2009 roku. Głównym celem naszej działalności
        jest opracowanie dokumentacji projektowej. Obszary, jakie z
        powodzeniem realizujemy to:
        <ul>
          <li>Projektowanie sieci elektroenergetycznych zewnętrznych,</li>
          <li>Projektowanie instalacji elektrycznych,</li>
          <li>Projektowanie instalacji niskoprądowych,</li>
          <li>Projektowanie instalacji wewnętrznych,</li>
          <li>Projektowanie oświetlenia drogowego,</li>
          <li>Certyfikacja urządzeń elektrycznych,</li>
        </ul>
      </Paragraph>
      <Paragraph>
        Od początku istnienia firmy współpracujemy z biurami projektowymi,
        architektami, firmami wykonawczymi i Inwestorami. Zajmujemy się
        kompleksowym projektowaniem, począwszy od koncepcji, poprzez obliczenia
        techniczne, projekty budowlane, wymagane uzgodnienia, aż do pełnej
        dokumentacji wykonawczej i powykonawczej uwzględniając przygotowanie
        kosztorysu. Nasza firma wpisana jest na listę wykonawców kwalifikowanych
        w ENRGA-OPERATOR SA. Grupę tworzy kilkudziesięciu pracowników. Ze
        względu na doświadczenie oraz wykwalifikowaną kadrę jesteśmy wstanie
        realizować najtrudniejsze zadania. Jako jedno z pierwszych na pomorzu
        rozpoczęliśmy projektowanie instalacji elektrycznych i niskoprądowych
        wewnętrznych w technologii BIM-3D. Realizujemy również inwestycje w
        formie „zaprojektuj i wybuduj”
      </Paragraph>
      <Paragraph>
        Prowadzona przez nas organizacja stale się rozwija, sukcesywnie
        rozszerzamy zakres świadczonych usług. Z powodzeniem realizujemy również
        projekty związane z elektro mobilnością oraz branżą OZE. Zajmujemy się
        projektowaniem i budową infrastruktury stacji ładowania pojazdów
        elektrycznych. Jesteśmy również dystrybutorem i partnerem czołowych
        Polskich producentów stacji ładowania, jakimi są Ekoenergetyka oraz EVB.
        W branży odnawialnych źródeł energii zajmujemy się projektowaniem,
        budową oraz dostarczaniem rozwiązań mających na celu redukcje kosztów
        stałych i budowę autonomii energetycznej.
      </Paragraph> */}
      {/* 
      <Paragraph>
        Samochody Elektryczne stają się rzeczywistością na Polskich drogach, ich
        ilość systematycznie rośnie a w parze z przyrostem użytkowników aut
        elektrycznych konieczny jest ciągły rozwój infrastruktury. Stąd też w
        krótkim czasie dostarczyliśmy rozwiązania dla naszych kontrahentów
        między innym zaufali nam:
        <ul>
          <li>BMW Bawaria Motors Gdańsk i Katowice;</li>
          <li>Makro Polska Al. Jerozolimskie, Bielany Przejazdowo,</li>
          <li>Galeria Sopot</li>
          <li>Oraz wielu klientów indywidualnych.</li>
        </ul>
      </Paragraph>
      <Paragraph>
        We współpracy z Klientami biznesowymi jak i indywidualnymi, stawiamy
        przede wszystkim na rzetelność i profesjonalizm w tym celu korzystamy
        wyłącznie ze sprawdzonych partnerów, materiałów i technologii, które
        zestawiając z naszym doświadczeniem przekładają się na kompletny i
        gotowy produkt inwestycyjny.
      </Paragraph>
      <HeadlineTwo>OZE</HeadlineTwo>
      <Paragraph>
        Nasze działania ukierunkowane są również w dziedzinie Odnawialnych
        Źródeł Energii. Mając na uwadze bardzo wysokie wymagania stawiane przez
        rynek usług OZE, dużą liczbę przeszkód, z którymi zmaga się branża,
        dzięki nabytemu doświadczeniu i możliwościom wypracowanym przez lata na
        rynku energetycznym w Polsce jesteśmy w stanie sprostać najcięższym
        wyzwaniom. Dzięki wykwalifikowanej kadrze inżynierskiej oraz
        rozbudowanej strukturze organizacyjnej gwarantujemy wysoki standard
        świadczonych usług, pełen profesjonalizm i etykę pracy.
      </Paragraph>
      <Paragraph>
        Cechuje nas indywidulane podejście do każdej prowadzonej inwestycji,
        skuteczność we wdrażaniu nowych innowacyjnych rozwiązań, a także
        terminowość i sumienność. Obszary, w jakich poruszamy się w branży OZE
        są:
        <ul>
          <li>Fotowoltaika i Pompy Ciepała</li>
          <li>Farmy fotowoltaicze</li>
          <li>Magazyny Energii</li>
          <li>Farmy wiatrowe</li>
          <li>Stacje ładowania pojazdów elektrycznych</li>
          <li>Audyty energetyczne</li>
          <li>Optymalizacja kosztów energii i gazu</li>
        </ul>
      </Paragraph> */}
      <HeadlineTwo>Zapraszamy do zapoznania się z naszą ofertą!</HeadlineTwo>
      {/* </First> */}
    </WrapperCenter>
  </>
);

export default Slider;
